var _path, _path2, _path3, _path4, _g, _circle, _circle2, _path5, _path6, _circle3, _circle4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 13v12H3v-8a2.006 2.006 0 012-2h14.17a2.006 2.006 0 001.42-.59l2.82-2.82a2.006 2.006 0 011.42-.59H59a2.006 2.006 0 012 2z",
    fill: "#a97c50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61 25v26a2.006 2.006 0 01-2 2H5a2.006 2.006 0 01-2-2V25z",
    fill: "#ffde55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59 11h-2a2.006 2.006 0 012 2v12h2V13a2.006 2.006 0 00-2-2z",
    fill: "#8b5e3c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25v26a2.006 2.006 0 01-2 2h2a2.006 2.006 0 002-2V25z",
    fill: "#ffcd00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 49a14.98 14.98 0 0011.98-24H20.02A14.98 14.98 0 0032 49zM32 19a14.962 14.962 0 00-11.98 6h23.96A14.962 14.962 0 0032 19z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 47,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 15h12v6H45z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 34,
    fill: "#2488ff",
    r: 15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 34,
    fill: "#6d6e71",
    r: 11
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13a2 2 0 00-2-2H9a2 2 0 00-2 2v2h10z",
    fill: "#58595b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45 15h12v6H45z",
    fill: "#d1e7f8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 34,
    fill: "#f1f2f2",
    r: 4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 47,
    fill: "#006df0",
    r: 2
  })));
}

export default __webpack_public_path__ + "59803e5010d72eacac4f0b5ecb511da2.svg";
export { SvgCamera as ReactComponent };